module.exports = __webpack_public_path__ + "img/icon-data-engineer.cf9d4095.svg";